import {createFetchListReducer} from 'common/reducers/utils';

const defaultReducer = createFetchListReducer({
  name: 'vehicle schedule',
  pluralName: 'vehicle schedules',
});

export default function vehicleSchedule(state = {
  isFetching: false,
  items: null,
}, action) {
  return defaultReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/common/reducers/vehicleSchedule.js